import { sha256 } from 'js-sha256';

/**
 NOTE: In order to save sent bytes from the client
 this method tries to run a fetch without uploading the
 query itself. If server and client versions differ
 the fetch reruns with query included
* */
const execQuery = async (query, variables) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const res = await fetch('/_internal/bff', {
    ...fetchOptions,
    method: 'POST',
    body: JSON.stringify({
      query: `hash:${sha256(query)}`,
      variables,
    }),
  });

  const json = await res.json();
  if (res.status === 200 && !json.errors?.length) {
    return json;
  }

  // If no success, try again with query
  return fetch('/_internal/bff', {
    ...fetchOptions,
    method: 'POST',
    body: JSON.stringify({
      query,
      variables,
    }),
  }).then(x => x.json());
};

export default execQuery;
